import { Pipe, PipeTransform } from '@angular/core';

import { CompanyValidationModel } from '../../companies/models/company.validation';

@Pipe({
  name: 'regex'
})
export class RegexPipe implements PipeTransform {
  transform( value : string, regex : Partial<CompanyValidationModel> ) : string {
    regex = regex || {};

    if (!value) {
      return '';
    }

    var validation = new RegExp(regex.validation);

    return validation
      ? value.replace(validation, regex.mask)
      : value;
  }
}